import { render, staticRenderFns } from "./AiBotPopup.vue?vue&type=template&id=417380f4&scoped=true&"
import script from "./AiBotPopup.vue?vue&type=script&lang=js&"
export * from "./AiBotPopup.vue?vue&type=script&lang=js&"
import style0 from "./AiBotPopup.vue?vue&type=style&index=0&id=417380f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417380f4",
  null
  
)

export default component.exports